import type { SceneMeta } from '@/types';

export const aluminumMeta: SceneMeta = {
  id: 'aluminum',
  name: '电解铝车间',
  shortName: '电解铝',
  icon: '⚡',
  thumbnail: '/scenes/aluminum.jpg',
  description: '160-500 kA 预焙阳极电解铝车间，含 4 槽阵列、氧化铝下料、抬包真空抽吸、整流变压器、阳极天车、烟气净化',
  designSize: { width: 1280, height: 760 },
  primaryColor: '#06b6d4',  // 青色，象征电解槽电解质
  difficulty: 'advanced',
  status: 'available',
};
